import React from 'react';
import OneSlider from './OneSlider';
import Brand from './Brand';
import SpaceshipsArea from './SpaceshipsArea';
import WeaponsArea from './WeaponsArea';
import ShieldsArea from './ShieldsArea';
import RepairKitsArea from './RepairKitsArea';
import GamesManage from './GamesManage';
import FeaturesArea from './FeaturesArea';
import HeaderOne from '../header/HeaderOne';
import Footer from '../footer/Footer';
import AboutUsArea from './AboutUsArea';

function Index() {
  return (
    <>
        <HeaderOne/>
        <main>
          <OneSlider/>
          <Brand/>
          <SpaceshipsArea/>
          <WeaponsArea/>
          <ShieldsArea/>
          <RepairKitsArea/>
          <AboutUsArea/>
          <GamesManage/>
          <FeaturesArea/>
        </main>
        <Footer/>
    </>
  )
}

export default Index;
